import {Action} from "redux";
import {isOrdersFiltersAction, OrdersFiltersAction} from "./actions";
import {DateType, GeoState, OrderStatus, Origin, PaidStatus, PaymentGroup, PaymentMethod} from "./data";

export type State = {
	selectedOrderStatus: OrderStatus
	selectedPaidStatus: PaidStatus
	selectedPaymentMethod: PaymentMethod
	selectedOrigin: Origin
	selectedState: GeoState
	selectedPaymentGroup: PaymentGroup
	selectedDateType: DateType
	fromDate: Date | null
	toDate: Date | null
}

export const reducer = (s: State, a: Action): State => {
	if(isOrdersFiltersAction(a)) {
		return ordersFiltersReducer(s, a.action)
	}
	return s
}

const ordersFiltersReducer = (s: State, a: OrdersFiltersAction): State => {
	switch (a.type) {
		case "set order status":
			const clearFilters = a.orderStatus === 'any'
			return {
				...s,
				selectedOrderStatus: a.orderStatus,
				selectedPaidStatus: clearFilters ? 'any' : s.selectedPaidStatus,
				selectedPaymentMethod: clearFilters ? 'any' : s.selectedPaymentMethod,
				selectedOrigin: clearFilters ? 'any' : s.selectedOrigin,
				selectedState: clearFilters ? 'any' : s.selectedState,
				selectedPaymentGroup: clearFilters ? 'any' : s.selectedPaymentGroup,
				selectedDateType: clearFilters ? 'any' : s.selectedDateType,
				fromDate: clearFilters ? null : s.fromDate,
				toDate: clearFilters ? null : s.toDate,
			}
		case "set paid status":
			return {...s, selectedPaidStatus: a.paidStatus}
		case "set payment method":
			return {...s, selectedPaymentMethod: a.paymentMethod}
		case "set origin":
			return {...s, selectedOrigin: a.origin}
		case "set state":
			return {...s, selectedState: a.state}
		case "set payment group":
			return {...s, selectedPaymentGroup: a.paymentGroup}
		case "set date type":
			const clearDates = a.dateType === 'any'
			return {
				...s,
				selectedDateType: a.dateType,
				fromDate: clearDates ? null : s.fromDate,
				toDate: clearDates ? null : s.toDate,
			}
		case "set from date":
			return {...s, fromDate: a.fromDate}
		case "set to date":
			return {...s, toDate: a.toDate}
		case "clear from date":
			return {...s, fromDate: null}
		case "clear to date":
			return {...s, toDate: null}
	}

	return s
}



// WEBPACK FOOTER //
// ./src/orders2/orders-filters/reducers.ts